import stopsMetaReducer from './stopsMetaReducer';

export default stopsMetaReducer;
